import styled from 'styled-components';

export const StyledContainer = styled.div`
	position: relative;
	width: 100%;
`;

export const StyledInputWrapper = styled.div<{ $focus: boolean }>`
	display: flex;
	align-items: center;
	justify-content: space-between;
	min-height: 40px;
	padding: 4px 12px;
	background: rgba(255, 255, 255, 0.05);
	border: 1px solid
		${(props) => (props.$focus ? '#2D70DA' : 'rgba(255, 255, 255, 0.1)')};
	border-radius: 8px;
	color: #ffffff;
	font-family: 'GT Walsheim Pro';
	font-size: 16px;
	cursor: pointer;
	transition: border-color 0.2s ease;

	&:hover {
		border-color: rgba(255, 255, 255, 0.3);
	}
`;

export const StyledArrow = styled.span<{ $active: boolean }>`
	font-size: 10px;
	color: rgba(255, 255, 255, 0.5);
	transform: rotate(${(props) => (props.$active ? '180deg' : '0deg')});
	transition: transform 0.2s ease;
	margin-left: 8px;
`;

export const StyledDropdown = styled.div`
	position: absolute;
	bottom: calc(100% + 4px);
	left: 0;
	right: 0;
	background: #1e2023;
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 8px;
	z-index: 100;
	overflow: hidden;
`;

export const StyledDropdownList = styled.div`
	max-height: 200px;
	overflow-y: auto;

	&::-webkit-scrollbar {
		width: 6px;
	}

	&::-webkit-scrollbar-track {
		background: rgba(255, 255, 255, 0.05);
	}

	&::-webkit-scrollbar-thumb {
		background: rgba(255, 255, 255, 0.2);
		border-radius: 3px;
	}
`;

export const StyledDropdownItem = styled.div<{
	$selected?: boolean;
	disabled?: boolean;
}>`
	display: flex;
	align-items: center;
	padding: 10px 12px;
	cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
	background: ${(props) =>
		props.$selected ? 'rgba(45, 112, 218, 0.2)' : 'transparent'};
	color: #ffffff;
	transition: background-color 0.15s ease;

	&:hover {
		background: ${(props) =>
			props.disabled ? 'transparent' : 'rgba(255, 255, 255, 0.1)'};
	}
`;

export const StyledSearchInput = styled.input`
	width: 100%;
	height: 36px;
	padding: 0 12px;
	background: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 6px;
	color: #ffffff;
	font-family: 'GT Walsheim Pro';
	font-size: 14px;
	outline: none;
	box-sizing: border-box;

	&::placeholder {
		color: rgba(255, 255, 255, 0.25);
	}

	&:focus {
		border-color: #2d70da;
	}
`;

export const StyledSearchWrapper = styled.div`
	padding: 8px;
	border-top: 1px solid rgba(255, 255, 255, 0.1);
`;

export const StyledSelectedItems = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 4px;
	margin-top: 4px;
`;

export const StyledSelectedItem = styled.span`
	display: inline-flex;
	align-items: center;
	gap: 4px;
	padding: 2px 8px;
	background: rgba(45, 112, 218, 0.2);
	border: 1px solid rgba(45, 112, 218, 0.4);
	border-radius: 4px;
	font-size: 12px;
	color: #ffffff;
`;

export const StyledSelectedItemRemove = styled.span`
	cursor: pointer;
	color: rgba(255, 255, 255, 0.5);
	font-size: 14px;
	line-height: 1;

	&:hover {
		color: #ff6b6b;
	}
`;
